export type TopNavActiveKey = 'news' | 'home' | 'ranking' | 'reviews' | 'survey' | 'more'

const ROUTE_ACTIVE_KEY_MAP: Record<string, TopNavActiveKey> = {
  news: 'news',
  'best-exchanges': 'ranking',
  reviews: 'reviews',
  inspections: 'survey',
  market: 'more',
  data: 'more',
  about: 'more',
  'about.html': 'more',
}

const normalizeRouteSegment = (segment: string) => {
  try {
    return decodeURIComponent(segment).trim().toLowerCase()
  } catch {
    return segment.trim().toLowerCase()
  }
}

/**
 * 根据当前路径解析头部顶级菜单高亮项，避免把首页静态固定为 active。
 */
export const resolveTopNavActiveKey = (path: string): TopNavActiveKey | null => {
  const normalizedPath = path.split(/[?#]/)[0]?.replace(/\/+$/, '') ?? ''
  const segments = normalizedPath.split('/').filter(Boolean).map(normalizeRouteSegment)

  if (segments.length === 0) {
    return 'home'
  }

  const firstSegment = segments[0] ?? ''
  const hasLocalePrefix = /^[a-z]{2}(?:-[a-z]{2})?$/.test(firstSegment)

  if (hasLocalePrefix && segments.length === 1) {
    return 'home'
  }

  const routeSegment = hasLocalePrefix ? segments[1] : firstSegment

  if (!routeSegment) {
    return 'home'
  }

  return ROUTE_ACTIVE_KEY_MAP[routeSegment] ?? null
}
